import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CancelIcon from "@mui/icons-material/Cancel";
import PageShell from "../common/PageShell";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "60vh",
    textAlign: "center",
    padding: "2rem",
  },
  icon: {
    fontSize: "4rem",
    marginBottom: "1rem",
  },
}));

export default function MembershipCancelPage() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <PageShell maxWidth="md">
      <Box className={classes.root}>
        <CancelIcon className={classes.icon} sx={{ color: "rgba(255, 255, 255, 0.4)" }} />
        <Typography variant="h4" sx={{ fontWeight: 800, color: "#ffffff", mb: 1 }}>
          Payment Cancelled
        </Typography>
        <Typography sx={{ color: "rgba(255, 255, 255, 0.6)", mb: 3, maxWidth: 450 }}>
          Your payment was cancelled. No charges were made. If you had a monthly
          recurring subscription, it has been stopped and no further payments will
          be collected. You can subscribe again anytime or continue using the free plan.
        </Typography>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button
            variant="contained"
            onClick={() => history.push("/membership/plans")}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              background: "linear-gradient(135deg, #E8A33D 0%, #E8A33D 100%)",
            }}
          >
            View Plans
          </Button>
          <Button
            variant="outlined"
            onClick={() => history.push("/lobby")}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              borderColor: "rgba(255, 255, 255, 0.2)",
              color: "rgba(255, 255, 255, 0.7)",
            }}
          >
            Back to Lobby
          </Button>
        </Box>
      </Box>
    </PageShell>
  );
}
